import {
    Backdrop,
    Button,
    CircularProgress, FormControl,
    Grid,
    InputLabel,
    makeStyles,
    MenuItem,
    Paper,
    Select,
    Typography
} from "@material-ui/core";
import Controls from "../../components/controls/Controls";
import CreateIcon from "@material-ui/icons/Create";
import SignaturePad from "react-signature-pad-wrapper";
import React, {useRef, useState} from "react";
import globalStyle from "../../styles/GlobalStyle";
import SaveIcon from '@material-ui/icons/Save';

const useStyles = makeStyles(theme => ({

    pickupInfoContainer: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        border: '1px solid grey'
    },
    signatureContainer: {},
    signatureBox: {
        border: '1px solid lightgrey'
    },
    signatureTitleContainer: {
        display: 'flex',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    signaturePenIcon: {
        marginLeft: theme.spacing(1)
    },
    secondaryButton: {
        colorInherit: theme.palette.grey
    },
    errorLabel: {
        margin: theme.spacing(2),
        fontSize: "0.75rem",

    },
    btnProgressWrapper: {
        margin: theme.spacing(1),
        position: 'relative',
        display: "inline-block"
    },
    btnProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },

}))

function PickupInfoForm(props) {
    const {
        handlePickupDetailSave,
        saving,
        roles,
        formValues,
        handleFormValueChange
    } = props;
    let signPadRef = useRef({});
    const [errors, setErrors] = useState({});
    const [showSignaturePad, setShowSignaturePad] = useState(true);
    const [signaturePadTitle, setSignaturePadTitle] = useState('Please sign below');
    const [validateOnChange, setValidateOnChange] = useState(false);
    const [open, setOpen] = React.useState(false);
    const handleSave = (e) => {
        if (!validateForm()) {
            setValidateOnChange(true)
            return;
        }
        handlePickupDetailSave(e, formValues);
        signPadRef.clear();
        setShowSignaturePad(true)
    }
    const handleInputChange = e => {
        const {name, value} = e.target;
        handleFormValueChange(name, value);
        if (validateOnChange) {
            validateForm({
                [name]: value
            })
        }
    }

    const validateForm = (fieldValues = formValues) => {
        let temp = {...errors};
        if ('name' in fieldValues) {
            temp.name = fieldValues.name ? '' : 'This field is required';
        }

        if ('role' in fieldValues) {
            temp.role = fieldValues.role ? '' : 'This field is required';
        }

        if ('comment' in fieldValues) {
            if (fieldValues.comment && fieldValues.comment.length > 255) {
                temp.comment = 'Cannot be more than 255 characters long';
            } else {
                temp.comment = '';
            }
        }

        if ('signature' in fieldValues) {
            temp.signature = fieldValues.signature ? '' : (signPadRef.isEmpty() ? 'This field is required' : 'Please save your signature first');
        }

        setErrors({
            ...temp
        })

        if (fieldValues === formValues)
            return Object.values(temp).every(x => x === "")
    }

    const saveSignature = (e) => {
        e.preventDefault();
        if (signPadRef.isEmpty()) {
            return;
        }
        setShowSignaturePad(false)
        setSignaturePadTitle('Your signature')
        setSignature(signPadRef.toDataURL())
    }

    const clearSignature = (e) => {
        e.preventDefault();
        signPadRef.clear();
        setSignature('')
    }

    const setSignature = (signature) => {

        handleFormValueChange('signature', signature)
        validateForm({signature: signature})
    }

    const undoSignature = (e) => {
        e.preventDefault();
        let data = signPadRef.toData();
        if (data) {
            data.pop(); // remove the last dot or line
            signPadRef.fromData(data);
        }
        setSignature(signPadRef.toDataURL())
    }

    const editSignature = (e) => {
        e.preventDefault();
        // if (signatureData && signPadRef) {
        //     signPadRef.fromData(signatureData);
        // }
        setShowSignaturePad(true);
    }
    const handleRoleClose = () => {
        setOpen(false);
    };

    const handleRoleOpen = () => {
        setOpen(true);
    };
    const classes = useStyles();
    const globalClasses = globalStyle();
    return (
        <Paper className={classes.pickupInfoContainer}>
            <Typography variant='h6' color='textSecondary'>Pickup Information</Typography>
            <Grid container spacing={4} className={classes.root}>
                <Grid item xs={12} md={6}>
                    <Controls.Input
                        name="name"
                        label="Name *"
                        value={formValues.name}
                        onChange={handleInputChange}
                        error={errors.name}
                    />
                </Grid>
                <Grid item xs={12} md={6}>

                    <FormControl style={{width: '100%'}}>
                        <InputLabel>Role *</InputLabel>
                        <Select
                            name='role'
                            open={open}
                            onClose={handleRoleClose}
                            onOpen={handleRoleOpen}
                            value={formValues.role}
                            onChange={handleInputChange}
                            error={!!errors.role}
                        >

                            {roles && roles.map(item => {
                                return <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
                            })}
                        </Select>
                        {errors.role && errors.role === '' ? '' :
                            <Typography variant='body2' className={globalClasses.errorLabel}>
                                {errors.role}
                            </Typography>}
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <Controls.Input
                        name="comment"
                        label="Comment"
                        placeholder="Enter comment if any.."
                        value={formValues.comment}
                        onChange={handleInputChange}
                        rows={5}
                        rowsMax={Infinity}
                        multiline
                        variant='outlined'
                        error={errors.comment}
                        inputProps={{maxLength: 255}}
                    />
                </Grid>

                <Grid item xs={12} className={classes.signatureContainer}>
                    <div>
                        <div className={classes.signatureTitleContainer}>
                            <Typography variant='body2' color='textSecondary' display='inline'>
                                {signaturePadTitle}
                            </Typography>
                            <CreateIcon className={classes.signaturePenIcon} color='primary'
                                        fontSize='small'/>
                        </div>

                        <div className={classes.signatureBox}
                             style={{
                                 display: showSignaturePad ? 'block' : 'none',
                                 borderColor: !errors.signature ? 'grey' : 'red'
                             }}>
                            <SignaturePad ref={ref => signPadRef = ref} redrawOnResize={true}
                                          height={300}/>
                        </div>
                        <div>
                            {errors.signature && errors.signature === '' ? '' :
                                <Typography variant='body2' className={globalClasses.errorLabel}>
                                    {errors.signature}
                                </Typography>}
                        </div>

                        <div className={classes.signaturePreviewBox}
                             style={{display: !showSignaturePad ? 'block' : 'none'}}>
                            <img src={formValues.signature} alt='signature' height={300}/>
                        </div>
                        {
                            showSignaturePad && <Button
                                color='primary'
                                onClick={saveSignature}>
                                Save signature
                            </Button>
                        }

                        {
                            showSignaturePad &&
                            <Button
                                className={classes.secondaryButton}
                                onClick={clearSignature}>
                                Clear
                            </Button>
                        }
                        {
                            showSignaturePad &&
                            <Button
                                color='inherit'
                                onClick={undoSignature}>
                                Undo
                            </Button>
                        }

                        {
                            !showSignaturePad && <Button
                                color='inherit'
                                onClick={editSignature}>
                                Edit
                            </Button>
                        }
                    </div>
                </Grid>
            </Grid>
            <div className={classes.btnProgressWrapper}>
                <Controls.Button
                    text="Save Pickup Information"
                    disabled={saving}
                    startIcon={<SaveIcon/>}
                    onClick={(event) => {
                        handleSave(event)
                    }}/>

                {saving && <CircularProgress size={24} className={classes.btnProgress}/>}
            </div>
            <Backdrop className={classes.backdrop} open={!!saving}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        </Paper>
    );
}

export default PickupInfoForm;
